import axios from "./AxiosService";

export default class ChangeAddressService {
  UpdateMemberAddress(changeAddressModel) {
    return axios
      .post("ChangeAddress", changeAddressModel, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        return response.data;
      });
  }
  GetServiceStatus() {
    return axios
      .get("ChangeAddress", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        return response.data;
      });
  }
}
